var render, staticRenderFns
import script from "./AxChoice.vue?vue&type=script&lang=ts&"
export * from "./AxChoice.vue?vue&type=script&lang=ts&"
import style0 from "./AxChoice.vue?vue&type=style&index=0&id=2769c97c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2769c97c",
  null
  
)

export default component.exports